export default __webpack_public_path__ + "static/catalogue-apparel-cdc06867e5948e38d79c2fbf7ce02f6a.png";